const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const GraphQLForm = require('app/graphql/Form');
const ListTable = require('app/ui/list/Table');
const Modal = require('app/ui/Modal');
const ConfirmModal = require('app/ui/modal/Confirm');
const IFrame = require('app/ui/modal/IFrame');

const SendModal = require('app/order/SendModal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-order-list',
            'tableContainerSelector': '.order-list-container',
            'filterFormSelector': '.order-list-search-form',
			'sendOrderSelector': '.btn-send-order',
			'sendOrderFormSelector': '.send-order-form',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$sendOrder =  $(this.settings.sendOrderSelector);
		this.$sendOrderFormSelector = $(this.settings.sendOrderFormSelector);

        this.initialize();
    }

    initialize() {
        var self = this;
        
        this.initializeFilterForm();
        this.initializeListTable();
	
    }

    initializeFilterForm(){
        var self = this;

        this.$filterByID = $('input[name="order_id"]',this.$filterForm);
        this.$filterByID.on('change',this.onSubmitFilterForm);
		
        this.$filterByBL = $('input[name="bl"]',this.$filterForm);
        this.$filterByBL.on('change',this.onSubmitFilterForm);

        this.$filterBySuppliers = $('select[id="suppliers"]',this.$filterForm);
        this.$filterBySuppliers.on('change',this.onSubmitFilterForm);
		
        this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
        this.$filterByRestaurant.on('change',this.onSubmitFilterForm);

        this.$filterByType = $('select[name="type"]',this.$filterForm);
        this.$filterByType.on('change',this.onSubmitFilterForm);
		
        this.$filterByStatus = $('select[name="status"]',this.$filterForm);
        this.$filterByStatus.on('change',this.onSubmitFilterForm);
		
        this.$filterByCreatedAt = $('input[name="day"]',this.$filterForm);
        this.$filterByCreatedAt.on('change',this.onSubmitFilterForm);

        this.$filterByMonth = $('select[name="month"]',this.$filterForm);
        this.$filterByMonth.on('change',this.onSubmitFilterForm);

        window.select2(this.$filterBySuppliers);
        window.select2(this.$filterByRestaurant);

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'restaurantName',
            'supplier { name email }',
            'total',
            'totalTTC',
            'createdAt',
			'restaurant { id }',
            'deliveryNumber',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped order-list',
            'id': 'list-orders',
            'length': 50,
            'graphQL': {
                'queryType': 'restaurantOrders',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('restaurant.order.createdAt.label'),
                    'class': 'order-date',
                    'ordered': true,
                    'orderType': 'createdAt',
                    'orderDir': 'DESC',
                    'render': function(item,index){
                        return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'id',
                    'label': window.translate('restaurant.order.id.label'),
                    'class': 'order-id',
                    'render': function(item,index){
                        return item.node.id;
                    },
                },
                {
                    'name': 'restaurant',
                    'label': window.translate('restaurant.order.restaurant.label'),
                    'class': 'order-restaurant',
                    'render': function(item,index){
                        return item.node.restaurantName;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('restaurant.order.supplier.label'),
                    'class': 'order-supplier',
                    'render': function(item,index){
                        return item.node.supplier.name;
                    },
                },
                {
                    'name': 'totalHT',
                    'label': window.translate('total'),
                    'class': 'order-totalHT',
                    'render': function(item,index){
                        return window.formatFloat(item.node.total) + ' &euro;';
                    },
                },
                {
                    'name': 'deliveryNumber',
                    'label': window.translate('restaurant.order.deliveryNumber.label'),
                    'class': 'order-bl',
                    'render': function(item,index){
                        let bl = item.node.deliveryNumber;
                        if(!bl){
                            bl = 'En attente';
                        }else{
                            bl = "N° "+bl;
                        }
                        return bl;
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'order-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

						// Ouverture d'une fancybox avec le détail de la commande
                        let $btnShow = $('<a/>')
                        .attr('href',"#")
                        .addClass('btn btn-link text-primary btn-order-show')
                        .attr('data-orderid',item.node.id)
                        .attr('title',window.translate('restaurant.order.actions.show.label'))
                        .append(
                            $('<i/>')
                            .addClass('fa fa-search')
                        );
                        btns.push($btnShow);

						//print = retour de PDF
                        let dropdownBtnId = 'dropdownPrintBtn'+item.node.id;
                        let $dropdownPrint = $('<div/>')
                        .addClass('dropdown')
                        .append(
                            $('<button/>')
                            .attr('id',dropdownBtnId)
                            .attr('type',"button")
                            .attr('data-bs-toggle',"dropdown")
                            .attr('aria-expanded',"false")
                            .addClass('btn btn-text text-primary')
                            .addClass('dropdown-toggle')
                            .attr('title',window.translate('print'))
                            .append(
                                $('<i/>')
                                .addClass('fa fa-print')
                            )
                        )
                        .append(
                            $('<ul/>')
                            .addClass('dropdown-menu p-2')
                            .attr('aria-labelledby',dropdownBtnId)
                            .append(
                                $('<li/>')
                                .append(
                                    $('<button/>')
                                    .addClass('btn btn-link btn-iframe dropdown-item')
                                    .attr('href',window.App.get('oldAdminHomeUrl')+"/orders/printOrder/simple/"+item.node.id)
                                    .append(window.translate('restaurant.order.actions.print.label'))
                                )
                                .append(
                                    $('<button/>')
                                    .addClass('btn btn-link btn-iframe dropdown-item')
                                    .attr('href',window.App.get('oldAdminHomeUrl')+"/orders/printOrder/simple/"+item.node.id+"/supplierOnly")
                                    .append(window.translate('restaurant.order.actions.printForSupplier.label'))
                                )
                            )
                        )
                        btns.push($dropdownPrint);


                        let $btnSend = $('<button/>')
						.addClass('btn btn-link text-primary')
                        .attr('title',window.translate('restaurant.order.actions.send.label') + item.node.id )
                        .attr('data-title',window.translate('restaurant.order.actions.send.label') + item.node.id )
						.attr('data-id',item.node.id)
						.attr('data-email',item.node.supplier.email)
						.attr('data-name',item.node.supplier.name)
                        .append(
                            $('<i/>')
                            .addClass('fa fa-envelope')
                        )
                        .on("click",function(){
                            let $btn = $(this);
                            self.onClickBtnSend($btn);
                        });
                        btns.push($btnSend);

                        let $btnReajust = $('<button/>')
                        .addClass('btn btn-link text-primary btn-reajust-show')
                        .attr('data-orderid',item.node.id)
                        .attr('title',window.translate('restaurant.order.actions.reajust.label'))
                        .append(
                            $('<i/>')
                            .addClass('fab fa-creative-commons-nc-eu')
                        );
                        btns.push($btnReajust);

						// Delete est une action commune à beaucoup d'endroits. Comment gérer ça de manière simple ?
                        let $btnDelete = $('<button/>')
                        .addClass('btn btn-link text-danger btn-delete')
                        .attr('title',window.translate('restaurant.order.actions.delete.label'))
                        .append(
                            $('<i/>')
                            .addClass('fa fa-trash')
                        )
                        .on('click',function(event){
                            self.onClickDelete(item.node);
                        });
                        btns.push($btnDelete);

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildGraphQLParameters(){

        let filters = {
        };

        if(this.$filterByID && this.$filterByID.val()){
            filters.id = parseInt(this.$filterByID.val());
        }

        if(this.$filterByBL && this.$filterByBL.val()){
            filters.deliveryNumber =  '%'+this.$filterByBL.val()+'%';
        }

        if(this.$filterByRestaurant && this.$filterByRestaurant.val()){
            filters.restaurant = parseInt(this.$filterByRestaurant.val());
        }

        if(this.$filterBySuppliers && this.$filterBySuppliers.val()){
			var selected = [];
			for (var option of this.$filterBySuppliers.val()) {
				selected.push(parseInt(option));
			  
			}
			if(selected.length > 0)
            	filters.suppliers = selected;
        }		

        if(this.$filterByCreatedAt && this.$filterByCreatedAt.val()){
            filters.createdAt =  "BETWEEN " + this.$filterByCreatedAt.val()+' '+this.$filterByCreatedAt.val();
        }else if(this.$filterByMonth && this.$filterByMonth.val()){
            let month = this.$filterByMonth.val();
            let start = moment(month).startOf('month').format('YYYY-MM-DD');
            let end = moment(month).endOf('month').format('YYYY-MM-DD');
            filters.createdAt =  "BETWEEN " + start+' '+end;
        }

        if(this.$filterByStatus && this.$filterByStatus.val()){
            filters.status =  parseInt(this.$filterByStatus.val());
        }else{
			filters.status = 1;
		}

        let parameters = {
            'filter' : filters
        };

        return parameters;
    }

    onClickDelete(order){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('restaurant.order.actions.delete.confirm',{'%orderId%':order.id}))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(order,modal)
            },
        })
        confirmModal.show();

    }

    proceedDelete(order,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'order': {
                'value': order.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantOrder",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onClickBtnSend($btn){
        let modal = new SendModal({
            'orderId': $btn.data('id'),
            'title': $btn.data('title'),
            'name': $btn.data('name'),
            'email': $btn.data('email')
        });
    }
}

module.exports = ListView;